export class PageDecrationSet {
  constructor() {
    this.$parent = document.querySelector('.js-parrent');
    this.$globalContainer = document.querySelector('.l-global-container');

    this._init();
  }

  _seting() {
    this.height = this.$globalContainer.offsetHeight;
    this.$parent.style.height = this.height + 'px';
  }

  _init() {
    this._seting();

    //ブラウザのリサイズ操作
    window.addEventListener('resize', () => {
      this._seting();
    });
  }
}
